import { SparklesIcon } from '@heroicons/react/16/solid'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { Heading } from '../../../../components/ui/Heading'
import { getVariantStyles } from '../../utils'

export default function MatchScoreMessage({
  matchingScore,
  talentName,
  variant = 'danger'
}) {
  const { t } = useTranslation()

  return (
    <React.Fragment>
      <div className='flex w-full items-center'>
        <div className='flex flex-row items-center text-base font-semibold text-gray-900'>
          <SparklesIcon className='mr-4 size-4 text-aivyBlue' />
          <Heading level={3}>{t('discover.assistant.assistant')}</Heading>
        </div>
      </div>
      <div className='mt-4 rounded-lg border border-lightGrey bg-[#EBEFFD66] p-4'>
        <div className='flex flex-row items-center gap-x-3'>
          <div
            className={clsx(
              'flex h-9 w-16 items-center justify-center rounded',
              getVariantStyles(variant)
            )}
          >
            <span className='text-xs font-medium'>{`${Math.round(matchingScore)}/100`}</span>
          </div>
          <Heading level={5} className={'text-left'}>
            {t(`discover.assistant.onboarding.score_message.${variant}.title`)}
          </Heading>
        </div>
        <div className='mt-2 text-left text-black'>
          <span className='text-left text-sm font-normal'>
            {t(
              `discover.assistant.onboarding.score_message.${variant}.description`,
              {
                talentName
              }
            )}
          </span>
        </div>
      </div>
    </React.Fragment>
  )
}

MatchScoreMessage.propTypes = {
  matchingScore: PropTypes.number.isRequired,
  talentName: PropTypes.string.isRequired
}
